"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isAnObject = function (value) {
    return typeof value === "object" && !Array.isArray(value) && value !== null;
};
/**
 * Checks if any bids exist in the provided bids object,
 * matched against the provided placement ID.
 */
function hasBids(_a) {
    var bids = _a.bids, placement = _a.placement;
    if (!isAnObject(bids) || Object.keys(bids).length === 0) {
        return false;
    }
    if (typeof placement !== "string") {
        return false;
    }
    var placementBids = placement in bids && bids[placement].bids;
    return Array.isArray(placementBids) && placementBids.length > 0;
}
exports.default = hasBids;
